// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"7d260dc2","208":"077c7a42"}[chunkId] + ".chunk.css";
};